import classNames from 'classnames';
import { FC } from 'react';

export interface CancelButtonProps {
  onCancel: () => void;
  className?: string;
}

export const CancelButton: FC<CancelButtonProps> = ({ onCancel, className }) => {
  return (
    <button className={classNames('btn btn-lg btn-flat-secondary btn-icon', className)} onClick={onCancel}>
      <i className="icon">close</i>
    </button>
  );
};
